export default {
    namespaced: true,
    state: {
        categoriesToll: null,
        categoriesVignette: null
    },
    mutations: {
        setTollCategories: (state, categoriesToll) => {
            state.categoriesToll = categoriesToll;
        },

        setVignetteCategories: (state, categoriesVignette) => {
            state.categoriesVignette = categoriesVignette;
        },
    },
    actions: {
        getCategoriesToll(context) {
            return this.$axios.get('/categories', {
                    params: {
                        type: 'toll'
                    }
                })
                .then(response => {
                    if(response.data.categories) {
                        context.commit('setTollCategories', response.data.categories);
                    }

                    return response;
                });
        },
        getCategoriesVignette(context) {
            return this.$axios.get('/categories', {
                    params: {
                        type: 'vignette'
                    }
                })
                .then(response => {
                    if(response.data.categories) {
                        context.commit('setVignetteCategories', response.data.categories);
                    }

                    return response;
                });
        },
    },
    getters: {
        getCategoriesToll: (state) => {
            return state.categoriesToll;
        },

        getCategoriesVignette: (state) => {
            return state.categoriesVignette;
        }
    }
}
